module.exports = __webpack_public_path__ + "static/media/health2.306e9e42.svg";